var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery"},[_c('CoolLightBox',{attrs:{"items":_vm.photos,"index":_vm.index},on:{"close":function($event){_vm.index = null}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }